angular.module('invoice')
    .factory('KsefConfig', function ($resource) {
        return $resource('/crm/api/ksef-config/:id', {id: '@id'}, {
            update: {method: 'PUT'},
            list: {method: 'GET', isArray: true},
            reset: {method: 'POST', url: '/crm/api/ksef-config/:id/reset'},
            sync: {method: 'POST', url: '/crm/api/ksef-config/:id/sync'}
        })
    })
    .factory('InvoiceAssignmentRule', function ($resource) {
        return $resource('/crm/api/invoice-assignment-rule/:id', {id: '@id'}, {
            update: {method: 'PUT'},
            list: {method: 'GET', isArray: true},
            createFromInvoice: {method: 'POST', url: '/crm/api/invoice-assignment-rule/from-invoice/:invoiceId'}
        })
    })
    .component('ksefConfig', {
        templateUrl: 'app/invoice/ksef/config.html',
        controller: function ($scope, $timeout, toastr, modals, KsefConfig, InvoiceAssignmentRule, FileUploaderCustom, Principal, InvoiceService) {
            this.InvoiceService = InvoiceService
            this.ruleModes = ['FIXED', 'ROUND_ROBIN', 'LEAST_LOADED']
            this.$onInit = () => {
                this.showForm = false
                this.resetForm(false)
                this.load()
                this.resetRuleForm()
                this.ruleFilters = {sellerNip: null}
                Principal.currentUser().then(user => {
                    this.canReadKSEF = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_KSEF_REGISTRY', 'ROLE_INVOICE_DOCUMENTS_KSEF_SETTINGS'])
                })
            }

            this.load = () => {
                KsefConfig.list().$promise.then(items => {
                    this.items = items
                })
            }

            this.resetForm = (show = true) => {
                this.form = {
                    active: true,
                    passwordEnabled: false
                }
                this.initUploaders()
                this.showForm = show
                this.rules = []
                this.resetRuleForm()
            }

            this.select = item => {
                this.form = angular.copy(item)
                this.form.client = item.client
                this.form.password = null
                this.form.passwordEnabled = false
                this.initUploaders()
                this.showForm = true
                this.loadRules(item)
            }

            this.closeForm = () => {
                this.resetForm(false)
            }

            this.save = () => {
                let payload = {
                    clientId: this.form.client?.id,
                    nip: this.form.nip,
                    active: this.form.active,
                    importStart: this.form.importStart ? moment(this.form.importStart).utc().format() : null
                }
                if (this.form.passwordEnabled) {
                    payload.password = this.form.password || ''
                }

                if (this.form.id) {
                    return KsefConfig.update({id: this.form.id}, payload).$promise.then(result => {
                        this.form = angular.copy(result)
                        this.form.client = result.client
                        this.form.password = null
                        this.form.passwordEnabled = false
                        this.initUploaders()
                        this.showForm = true
                        this.load()
                        this.loadRules(this.form)
                        toastr.success("Zapisano")
                    })
                }

                return KsefConfig.save(payload).$promise.then(result => {
                    this.form = angular.copy(result)
                    this.form.client = result.client
                    this.form.password = null
                    this.form.passwordEnabled = false
                    this.initUploaders()
                    this.showForm = true
                    this.load()
                    this.loadRules(this.form)
                    toastr.success("Zapisano")
                })
            }

            this.remove = item => {
                let content = item.client?.fullName || item.nip || "#" + item.id
                return modals.confirmDelete(content, () => KsefConfig.delete({id: item.id}).$promise.then(() => {
                    if (this.form?.id === item.id) {
                        this.resetForm()
                    }
                    this.load()
                }))
            }

            this.resetRuleForm = () => {
                this.ruleForm = {
                    active: true,
                    assignMode: 'ROUND_ROBIN',
                    confidential: false,
                    users: [],
                    accessGroups: [],
                    sourceType: 'KSEF',
                    scope: 'GLOBAL'
                }
            }

            this.editRule = rule => {
                this.ruleForm = angular.copy(rule)
                this.ruleForm.users = rule.users || []
                this.ruleForm.accessGroups = rule.accessGroups || []
            }

            this.saveRule = () => {
                if (!this.form?.client?.id) {
                    return
                }
                let payload = angular.copy(this.ruleForm)
                payload.buyer = {id: this.form.client.id}
                payload.sourceType = payload.sourceType || 'KSEF'
                payload.scope = payload.scope || 'GLOBAL'
                if (payload.id) {
                    return InvoiceAssignmentRule.update({id: payload.id}, payload).$promise.then(() => {
                        this.resetRuleForm()
                        this.loadRules(this.form)
                        toastr.success("Zapisano regułę")
                    })
                }
                return InvoiceAssignmentRule.save(payload).$promise.then(() => {
                    this.resetRuleForm()
                    this.loadRules(this.form)
                    toastr.success("Dodano regułę")
                })
            }

            this.deleteRule = rule => {
                let content = rule?.sellerNip || "#" + rule?.id
                return modals.confirmDelete(content, () => InvoiceAssignmentRule.delete({id: rule.id}).$promise.then(() => {
                    this.loadRules(this.form)
                }))
            }

            this.loadRules = item => {
                let clientId = item?.client?.id || item?.clientId || item?.id
                if (!clientId) {
                    this.rules = []
                    return
                }
                let params = {buyerClientId: clientId}
                if (this.ruleFilters?.sellerNip) {
                    params.sellerNip = this.ruleFilters.sellerNip
                }
                InvoiceAssignmentRule.list(params).$promise.then(items => {
                    this.rules = items
                })
            }

            this.clearRuleFilter = () => {
                this.ruleFilters = {sellerNip: null}
                this.loadRules(this.form)
            }

            this.resetSecrets = item => {
                let content = item.client?.fullName || item.nip || "#" + item.id
                return modals.confirm("Czy na pewno chcesz zresetować sekrety dla: " + content + "?", () => {
                    return KsefConfig.reset({id: item.id}).$promise.then(() => {
                        this.load()
                        toastr.success("Zresetowano sekrety")
                    })
                })
            }

            this.syncNow = item => {
                let content = item.client?.fullName || item.nip || "#" + item.id
                return modals.confirm("Wykonać synchronizację teraz dla: " + content + "?", () => {
                    return KsefConfig.sync({id: item.id}).$promise.then(() => {
                        this.load()
                        toastr.success("Synchronizacja uruchomiona")
                    })
                })
            }

            this.initUploaders = () => {
                if (!this.form?.id) {
                    this.certUploader = null
                    this.keyUploader = null
                    return
                }
                this.certUploader = null
                this.keyUploader = null
                $timeout(() => {
                    this.certUploader = FileUploaderCustom.create(`/crm/api/ksef-config/${this.form.id}/cert`, () => ({}), () => {
                        this.load()
                        this.certUploader?.clearQueue()
                    }, {multiple: false})
                    this.keyUploader = FileUploaderCustom.create(`/crm/api/ksef-config/${this.form.id}/key`, () => ({}), () => {
                        this.load()
                        this.keyUploader?.clearQueue()
                    }, {multiple: false})
                })
            }
        }
    })
